<script>
  import { getContext, onDestroy } from 'svelte';
  import { format } from 'svelte-i18n';
  import { link } from 'svelte-navigator';
  import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Row } from '@sveltestrap/sveltestrap';
  import { add, differenceInDays, endOfDay, startOfDay } from 'date-fns';

  import { DateFilter } from '@client/components/filters/date';
  import { SearchFilter } from '@client/components/filters/search';

  import { appStore } from '@client/stores/app';
  import { days, loadingHistory, pushHistory } from '@client/stores/push-history';

  import { QueryParams } from '@client/utils/query-params';

  import { PushHistoryCalendar, PushHistoryFilters, PushHistoryTable, PushModal } from './components';

  const { basepath } = getContext('config');

  let config;
  let endDate = endOfDay(new Date());
  let show = false;
  let startDate = startOfDay(add(new Date(), { days: -89 }));
  let view = 'list';
  let search = QueryParams.get('search');
  let filtered = [];
  let showFilters = true;

  const onDays = (n) => {
    if (n > $days) {
      days.set(n);
    }
  };

  const onNewPush = () => {
    config = undefined;
    show = true;
  };

  const onPush = (entry) => {
    config = entry;
    show = true;
  };

  $: if ($loadingHistory) {
    $appStore.loading = true;
  } else {
    $appStore.loading = false;
  }

  onDestroy(() => {
    $appStore.loading = false;
  });

  $: filtered = search?.length
    ? $pushHistory.filter((row) => {
        const searchValue = search.toLowerCase();

        return [...Object.values(row), ...Object.values(row?.note)].some((field) => {
          if (typeof field === 'string') {
            return field.toLowerCase().includes(searchValue);
          }

          return false;
        });
      })
    : $pushHistory;
</script>

<div class="page">
  <div class="page-header">
    <Container fluid>
      <Breadcrumb>
        <BreadcrumbItem>
          <a href="{basepath}/signatures" use:link>{$format('label.SIGNATURES')}</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>{$format('label.PUSHER')}</BreadcrumbItem>
      </Breadcrumb>

      <Row>
        <Col xs="6" sm="6" md="8">
          <h1 class="page-title">
            {$format('label.PUSH_HISTORY')}
          </h1>
        </Col>
        <Col class="text-right">
          <Button color="secondary" on:click={onNewPush}>{$format('label.NEW_PUSH')}</Button>
          <PushModal bind:show {config} />
        </Col>
      </Row>
    </Container>
  </div>

  <div class="page-content py-3">
    <PushHistoryFilters bind:view onView={(newView) => (view = newView)} bind:showFilters>
      <span slot="left">
        {#if view === 'list'}
          <SearchFilter bind:search />
        {/if}
      </span>
      {#if view === 'list'}
        <DateFilter
          align="right"
          clearable={false}
          isRange
          isMultipane
          showPresets
          bind:startDate
          bind:endDate
          showPresetsOnly={$appStore.mobile}
          onDateChange={({ startDate }) => {
            onDays(differenceInDays(new Date(), new Date(startDate)) + 1);
          }}
        />
      {/if}
    </PushHistoryFilters>
    <div class="py-3">
      {#if view === 'calendar'}
        <PushHistoryCalendar history={$pushHistory} loading={$loadingHistory} {onDays} {onPush} />
      {:else}
        <PushHistoryTable
          {startDate}
          {endDate}
          bind:history={filtered}
          loading={$loadingHistory}
          {onPush}
          bind:showFilters
        />
      {/if}
    </div>
  </div>
</div>
